module.exports = __webpack_public_path__ + "static/media/img9.c5c87604.jpeg";